import React from 'react';
import { Link } from 'react-router-dom';

interface AtletaCardProps {
    atleta: {
        id: string;
        usuario?: {
            id?: string;
            nome: string;
            username: string;
            imagemUrl?: string | null;
            bannerUrl?: string | null;
        } | null;
    };
}

const AtletaCard: React.FC<AtletaCardProps> = ({ atleta }) => {
    const usuario = atleta.usuario;
    const nomeExibicao = usuario?.nome ?? 'Atleta';
    const usernameExibicao = usuario?.username ? `@${usuario.username}` : '';
    const avatar = usuario?.imagemUrl ?? '/assets/images/user.png';

    return (
        <Link
            to={`/userpage/${atleta.id}`}
            // Sem `mb-3`: ela CONFLITA com `h-100`. Com altura 100% da coluna, a
            // margem fica FORA da caixa do card e transborda a coluna em vez de
            // separar as linhas — os cards se encostavam (achado de QA do owner,
            // 2026-08-31). O espaçamento vertical passou a ser responsabilidade
            // do grid, via `gy-3` na `.row` de `SearchPage.tsx`, que é onde ele
            // pertence: quem sabe a distância entre linhas é o container, não o
            // filho.
            className="card w-100 border-0 shadow-xss rounded-xxl overflow-hidden h-100 text-decoration-none"
        >
            <div className="card-body d-flex p-3 align-items-center">
                <img
                    src={avatar}
                    alt={nomeExibicao}
                    className="rounded-circle"
                    style={{ width: 48, height: 48, objectFit: 'cover' }}
                />
                <div className="ms-3">
                    <span className="fw-700 text-grey-900 font-xssss d-block">{nomeExibicao}</span>
                    <p className="font-xssss text-grey-500 mb-0">{usernameExibicao}</p>
                </div>
            </div>
        </Link>
    );
};

export default AtletaCard;
